import React, { useState, useEffect, useContext } from "react";
import { Modal, Button, FloatingLabel, Form } from "react-bootstrap";

import Utils from "../../../Utils";
import ContextComponent from "../../../AppContext";

const UserDialog = ({ props = {} }) => {
  let { setLoadingState, languages, setLanguagues, setCanRedirectToLogin } =
    useContext(ContextComponent);

  props.userProfileData = props.userProfileData ?? {};
  let [showUserDialog, setShowUserDialog] = useState(false);
  let [showDialog, setShowDialog] = useState(false);
  let [langs, setLangs] = useState([]);
  let [dialogMode, setDialogMode] = useState("");
  let [submitLabel, setSubmitLabel] = useState("");
  let [userProfile, setUserProfile] = useState({});

  let [modalTitle, setModalTitle] = useState("");
  let [progressText, setProgressText] = useState("");

  let profileAttrs = [
    "firstName",
    "lastName",
    "pronoun",
    "profileName",
    "department",
    "title",
    "salutation",
    "userId",
    "id",
    "languageCode",
    "rtl",
    "specialText",
  ];

  useEffect(() => {
    let tempUserProfile = { ...props.userProfileData };
    let mode = tempUserProfile.mode || "create";
    setModalTitle(tempUserProfile.dialogTitle);
    setSubmitLabel(tempUserProfile.dialogSubmitBtnLabel);
    setShowUserDialog(tempUserProfile.showUserDialog);
    setProgressText(tempUserProfile.progressText);
    setDialogMode(tempUserProfile.mode);

    let tempUserData = {};
    profileAttrs.forEach((attr) => {
      tempUserData[attr] = tempUserProfile.userData[attr] ?? "";
    });

    // console.log(tempUserData);

    setUserProfile(tempUserData);
  }, [props.userProfileData]);

  useEffect(() => {
    if (showUserDialog) {
      if (languages.length > 0) {
        setLangs(languages);
        setShowDialog(true);
      } else {
        const langSuccess = (res) => {
          // console.log(res.data);
          setLangs(res.data);
          setLanguagues(res.data);
          setShowDialog(true);
        };
        const langFail = ({ error }) => {
          error?.message?.length && console.log(error);
          setErrorMessage(error);
          Utils.handleDefaultError({
            error,
            setLoadingState,
            setCanRedirectToLogin,
          });
        };
        Utils.getLanguages().then(langSuccess, langFail);
      }
    }
  }, [showUserDialog]);

  const handleClose = () => {
    setShowUserDialog(false);
  };

  let [errorMessage, setErrorMessage] = useState("");

  const profileFieldChangeHandler = (e) => {
    let fieldName = e.currentTarget.id || "";
    let fieldObj = {};
    let fieldValue =
      fieldName === "rtl" ? e.currentTarget.checked : e.currentTarget.value;
    fieldObj[fieldName] = fieldValue;
    let updatedObj = { ...userProfile, ...fieldObj };
    // console.log(updatedObj);
    setUserProfile(updatedObj);
  };

  const handleUpdate = (e) => {
    let userObjToBeSubmit = { ...userProfile };

    setLoadingState({
      applyMask: true,
      text: progressText,
    });

    //setUserProfiles

    const anyCallback = () => {
      setLoadingState({
        applyMask: false,
      });
      setErrorMessage("");
      setShowUserDialog(false);
    };

    const editSuccess = (response) => {
      // console.log(response);
      anyCallback();

      let tempUserProfiles = [...props.userProfileData.userProfiles];
      let tempUserProfile = [];
      // console.log(tempUserProfile);
      tempUserProfiles.forEach((up) => {
        if (up.id === userProfile.id) {
          tempUserProfile.push(userObjToBeSubmit);
        } else {
          tempUserProfile.push(up);
        }
      });
      // console.log(tempUserProfile);
      props.userProfileData.setUserProfiles(tempUserProfile);
    };

    const createSuccess = (response) => {
      // console.log(response);
      anyCallback();

      let tempUserProfiles = [...props.userProfileData.userProfiles];
      tempUserProfiles.push({
        ...response.data,
        userId: userObjToBeSubmit.userId,
      });
      // console.log(tempUserProfiles);

      props.userProfileData.setUserProfiles(tempUserProfiles);
    };

    const fail = ({ error }) => {
      error?.message?.length && console.log(error);
      setErrorMessage(error);
      Utils.handleDefaultError({
        error,
        setLoadingState,
        setCanRedirectToLogin,
      });
    };

    if (dialogMode === "edit") {
      // console.log(userObjToBeSubmit);
      // console.log(userProfile.id);
      // debugger;
      // return false;
      Utils.editProfile(userObjToBeSubmit, userProfile.id).then(
        editSuccess,
        fail
      );
    } else {
      // console.log(userObjToBeSubmit);
      // debugger;
      // return false;
      Utils.createProfile(userObjToBeSubmit).then(createSuccess, fail);
    }
  };

  return (
    <>
      {showDialog && (
        <Modal centered show={showUserDialog} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title className="indi-modal-edit-user-profile-header-title">
              {modalTitle}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              className={`indi-modal-edit-user-profile-profile-section indi-modal-edit-user-profile-profile`}
            >
              <FloatingLabel
                label="Profile name"
                className="indi-modal-edit-user-profile-floating-inputs"
              >
                <Form.Control
                  type="text"
                  className="indi-input-field"
                  id="profileName"
                  placeholder="Enter profile name"
                  autoComplete="off"
                  defaultValue={userProfile.profileName}
                  onChange={profileFieldChangeHandler}
                />
              </FloatingLabel>
              <FloatingLabel
                label="First name"
                className="indi-modal-edit-user-profile-floating-inputs"
              >
                <Form.Control
                  type="text"
                  className="indi-input-field"
                  id="firstName"
                  placeholder="Enter first name"
                  autoComplete="off"
                  defaultValue={userProfile.firstName}
                  onChange={profileFieldChangeHandler}
                />
              </FloatingLabel>
              <FloatingLabel
                label="Last name"
                className="indi-modal-edit-user-profile-floating-inputs"
              >
                <Form.Control
                  type="text"
                  className="indi-input-field"
                  id="lastName"
                  placeholder="Enter last name"
                  autoComplete="off"
                  defaultValue={userProfile.lastName}
                  onChange={profileFieldChangeHandler}
                />
              </FloatingLabel>
              <FloatingLabel
                label="Title"
                className="indi-modal-edit-user-profile-floating-inputs"
              >
                <Form.Control
                  type="text"
                  className="indi-input-field"
                  id="title"
                  placeholder="Enter title"
                  autoComplete="off"
                  defaultValue={userProfile.title}
                  onChange={profileFieldChangeHandler}
                />
              </FloatingLabel>
              <FloatingLabel
                label="Department"
                className="indi-modal-edit-user-profile-floating-inputs"
              >
                <Form.Control
                  type="text"
                  className="indi-input-field"
                  id="department"
                  placeholder="Enter department"
                  autoComplete="off"
                  defaultValue={userProfile.department}
                  onChange={profileFieldChangeHandler}
                />
              </FloatingLabel>

              <FloatingLabel
                label="Salutation"
                className="indi-modal-edit-user-profile-floating-inputs"
              >
                <Form.Control
                  type="text"
                  className="indi-input-field"
                  id="salutation"
                  placeholder="Enter salutation"
                  autoComplete="off"
                  defaultValue={userProfile.salutation}
                  onChange={profileFieldChangeHandler}
                />
              </FloatingLabel>

              <FloatingLabel
                label="Pronoun"
                className="indi-modal-edit-user-profile-floating-inputs"
              >
                <Form.Control
                  type="text"
                  className="indi-input-field"
                  id="pronoun"
                  placeholder="Enter pronoun"
                  autoComplete="off"
                  defaultValue={userProfile.pronoun}
                  onChange={profileFieldChangeHandler}
                />
              </FloatingLabel>

              <FloatingLabel
                label="Special Text"
                className="indi-modal-edit-user-profile-floating-inputs"
              >
                <Form.Control
                  type="text"
                  className="indi-input-field"
                  id="specialText"
                  placeholder="Enter Special Text"
                  autoComplete="off"
                  defaultValue={userProfile.specialText}
                  onChange={profileFieldChangeHandler}
                />
              </FloatingLabel>

              <FloatingLabel label="Select language">
                <Form.Select
                  defaultValue={userProfile?.languageCode || langs[0].languageCode}
                  id="languageCode"
                  // size="sm"
                  // className="indi-input-field indi-input-select-field"
                  onChange={profileFieldChangeHandler}
                >
                  {langs?.map((lang, index) => (
                    <option value={lang.languageCode} key={index}>
                      {lang.languageText}
                    </option>
                  ))}
                </Form.Select>
              </FloatingLabel>

              <Form.Check
                type="switch"
                className="indi-input-switch-field indi-input-field"
                id="rtl"
                label="is RTL?"
                defaultChecked={userProfile.rtl}
                onChange={profileFieldChangeHandler}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="indi-user-profile-settings-error-msg">
              {errorMessage}
            </div>
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleUpdate}>
              {submitLabel}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default UserDialog;
